<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\changeAvaManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面の右上にあるプロフィール画像にマウスを置くと、プルダウンメニューが表示されます。「個人設定」メニューをクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeAvaManual-2.png" alt="" /></div>
                <div>
                    <p>② 個人設定画面が表示され、画面の上部にあるプロフィール画像をクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeAvaManual-3.png" alt="" /></div>
                <div>
                    <p>③ 「画像選択」ボタンを押下し、新しいプロファイル画像を選択します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeAvaManual-4.png" alt="" /></div>
                <div>
                    <p>④ 「保存」ボタンを押下し、プロファイル画像を保存します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/changeAva_manual.vue